module.exports = __webpack_public_path__ + "media/images/partner/hornung-5fa54eb1a7985991869898e2357b460b.jpg";